import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useState } from "react";

import styled from "styled-components/macro";

import { faHandHoldingUsd } from "@fortawesome/pro-duotone-svg-icons";
import { AnimatePresence, motion } from "framer-motion";

import FnrHoverButton from "UI/FnrHoverButton";

import PastPledge from "./PastPledge";
import PledgeDetail from "./PledgeDetail";
import { useUserPledgesList } from "./UserPledgesListContext";

PledgeList.propTypes = {
  showSectionTitle: PropTypes.bool,
  userID: PropTypes.number,
  onPledgeEnd: PropTypes.func,
};

export default function PledgeList({ showSectionTitle, userID, onPledgeEnd }) {
  const {
    state: { pledges },
  } = useUserPledgesList();
  const [showPastPledges, setShowPastPledges] = useState(false);

  const activePledges = pledges.filter(
    (pledgeData) => pledgeData.status === "active"
  );
  const pastPledges = pledges.filter(
    (pledgeData) =>
      pledgeData.status === "closed" || pledgeData.status === "fulfilled"
  );

  const toggleShowPastPledges = () =>
    setShowPastPledges((currentVal) => !currentVal);

  return (
    <Wrapper>
      <Inside>
        {showSectionTitle ? (
          <Title>
            <TitleIcon icon={faHandHoldingUsd} /> Pledges
          </Title>
        ) : null}

        <div>
          {activePledges.map((pledgeData) => (
            <PledgeDetail
              key={pledgeData.pledgeID}
              userID={userID}
              onPledgeEnd={onPledgeEnd}
              {...pledgeData}
            />
          ))}
        </div>

        {pastPledges.length > 0 && (
          <>
            <PastPledgesButtonWrapper>
              <FnrHoverButton
                onClick={toggleShowPastPledges}
                bgColor="var(--pledgesProgressBarBackground)"
              >
                <PastPledgesButtonContent>
                  Past Pledges
                  <PastPledgesIcon
                    className="fas fa-chevron-down"
                    initial={{ y: 1 }}
                    animate={{
                      rotate: showPastPledges ? -180 : 0,
                      y: showPastPledges ? 0 : 1,
                    }}
                  />
                </PastPledgesButtonContent>
              </FnrHoverButton>
            </PastPledgesButtonWrapper>
            <AnimatePresence>
              {showPastPledges && (
                <PastPledgesContainer
                  initial={{ height: 0 }}
                  animate={{ height: "auto" }}
                  exit={{ height: 0 }}
                >
                  <PastPledgesBorder />
                  {pastPledges.map((pledgeData) => (
                    <PastPledge key={pledgeData.pledgeID} {...pledgeData} />
                  ))}
                </PastPledgesContainer>
              )}
            </AnimatePresence>
          </>
        )}
      </Inside>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  position: relative;
  overflow: hidden;
`;
const Inside = styled.div`
  padding: 27px 40px 0 40px;
  .user_profile & {
    padding: 20px;
    padding-bottom: 0;
    @media screen and (max-width: 680px) {
      padding: 12px;
      padding-bottom: 0;
    }
  }
`;
const Title = styled.div`
  font-size: 24px;
  display: flex;
  align-items: center;
  padding: 4px 0 16px;
  color: #384a5d;
`;
const TitleIcon = styled(FontAwesomeIcon)`
  margin-right: 6px;
  font-size: 18px;
`;
const PastPledgesButtonWrapper = styled.div`
  margin-left: 5px;
  width: fit-content;
  min-height: 34px;
  position: relative;
`;

const PastPledgesIcon = styled(motion.div)`
  margin-left: 4px;
`;

const PastPledgesContainer = styled(motion.div)`
  overflow: hidden;
`;
const PastPledgesBorder = styled.div`
  height: 4px;
  border-bottom: 1px solid var(--pledgesProgressBarBackground);
  margin: 0 16px;
`;

const PastPledgesButtonContent = styled.div`
  font-size: 14px;
`;
